import React, { useState } from "react";
import { Table, TableBody, TableContainer } from "@mui/material";
import { ServicesTableHead } from "./ServiceTableHead";
import { ServiceRow } from "./ServiceRow";

export const ServiceTable = ({ services = [] }) => {
    const [selectedRows, setSelectedRows] = useState([]);

    return (
        <TableContainer sx={{ tableLayout: "fixed", width: "100%" }}>
            <Table>
                <ServicesTableHead />
                <TableBody>
                    {services.map((service) => (
                        <ServiceRow
                            key={service.id}
                            serviceData={service}
                            id={service.id}
                            handleSelect={setSelectedRows}
                            selected={selectedRows}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
